import {
    BackButton,
    convertFromBoolean,
    convertToBoolean,
    Divider,
    Form,
    FormDropDown,
    FormInput,
    FormRadio,
    Header,
    setAttributeEntity,
    useAlignments,
    useSizes,
} from 'metrix-common3';
import React from 'react';
import { FormattedMessage } from 'react-intl';

const ProfileDwellingHeatingSystem = (props) => {
    const sizes = useSizes();
    const alignments = useAlignments();

    return (
        <React.Fragment>
            <BackButton clickEvent={props.backEvent} />
            <Divider top={sizes.md} />
            <Header
                size={sizes.md}
                textAlign={alignments.left}
                text={<FormattedMessage id='Profile_Dwellings_HeatingSystem.heatingSystem' />}
            />
            <Form
                label={<FormattedMessage id='Profile_Dwellings_HeatingSystem.heatingSystemDetails' />}
                allowEdit={props.allowEdit}
                saveEvent={() => props.doUpsertPolicy()}
                cancelEvent={() => props.doGetPolicy()}
            >
                <FormDropDown
                    label={<FormattedMessage id='Profile_Dwellings_HeatingSystem.type' />}
                    value={props.heatingSystem?.type}
                    references={props.reference.references?.HeaterType}
                    referencesEvent={() => props.reference.doGetReferences('HeaterType')}
                    changeEvent={(value) => {
                        setAttributeEntity(`${props.dotProp}type`, value, props.doReducePolicyElement);
                        if (value.code === 'I') {
                            props.doReducePolicyElement({ code: `${props.dotProp}isFirePlace`, value: true });
                        } else {
                            props.doReducePolicyElement({ code: `${props.dotProp}isFirePlace`, value: false });
                        }
                    }}
                    allowEdit
                />
                <FormDropDown
                    label={<FormattedMessage id='Profile_Dwellings_HeatingSystem.fuelType' />}
                    value={props.heatingSystem?.fuelType}
                    references={props.reference.references?.PrimaryFuel}
                    referencesEvent={() => props.reference.doGetReferences('PrimaryFuel')}
                    changeEvent={(value) =>
                        setAttributeEntity(`${props.dotProp}fuelType`, value, props.doReducePolicyElement)
                    }
                    allowEdit
                />
                {props.heatingSystem?.fuelType && props.heatingSystem.fuelType.code === 'W' && (
                    <FormInput
                        label={<FormattedMessage id='Profile_Dwellings_HeatingSystem.numberOfChords' />}
                        value={props.heatingSystem?.numberOfChords}
                        changeEvent={(value) =>
                            props.doReducePolicyElement({ code: `${props.dotProp}numberOfChords`, value })
                        }
                        allowEdit
                    />
                )}
                {props.heatingSystem &&
                    ((props.heatingSystem.fuelType && props.heatingSystem.fuelType.code === 'W') ||
                        props.heatingSystem.isFirePlace === true) && (
                        <FormDropDown
                            label={<FormattedMessage id='Profile_Dwellings_HeatingSystem.chimneyType' />}
                            value={props.heatingSystem?.chimneyType}
                            references={props.reference.references?.ChimneyType}
                            referencesEvent={() => props.reference.doGetReferences('ChimneyType')}
                            changeEvent={(value) =>
                                setAttributeEntity(`${props.dotProp}chimneyType`, value, props.doReducePolicyElement)
                            }
                            allowEdit
                        />
                    )}
                {props.heatingSystem?.fuelType && props.heatingSystem.fuelType.code === 'I' && (
                    <FormInput
                        label={<FormattedMessage id='Profile_Dwellings_HeatingSystem.oilTankYear' />}
                        value={props.heatingSystem?.oilTankYear}
                        changeEvent={(value) =>
                            props.doReducePolicyElement({ code: `${props.dotProp}oilTankYear`, value })
                        }
                        allowEdit
                    />
                )}
                {props.heatingSystem?.fuelType && props.heatingSystem.fuelType.code === 'I' && (
                    <FormDropDown
                        label={<FormattedMessage id='Profile_Dwellings_HeatingSystem.oilTankLocation' />}
                        value={props.heatingSystem?.fuelStorageLocation}
                        references={props.reference.references?.OilTankLocation}
                        referencesEvent={() => props.reference.doGetReferences('OilTankLocation')}
                        changeEvent={(value) =>
                            setAttributeEntity(
                                `${props.dotProp}fuelStorageLocation`,
                                value,
                                props.doReducePolicyElement,
                            )
                        }
                        allowEdit
                    />
                )}
                <FormInput
                    label={<FormattedMessage id='Profile_Dwellings_HeatingSystem.year' />}
                    value={props.heatingSystem?.year}
                    changeEvent={(value) => props.doReducePolicyElement({ code: `${props.dotProp}year`, value })}
                    allowEdit
                />
                {props.allowPrimary && (
                    <FormRadio
                        label={<FormattedMessage id='Profile_Dwellings_HeatingSystem.primary' />}
                        value={props.heatingSystem && { code: convertFromBoolean(props.heatingSystem.primary) }}
                        references={props.reference.references?.YesNo}
                        referencesEvent={() => props.reference.doGetReferences('YesNo')}
                        changeEvent={(value) =>
                            props.doReducePolicyElement({
                                code: `${props.dotProp}primary`,
                                value: convertToBoolean(value.code),
                            })
                        }
                        allowEdit
                    />
                )}
                {props.heatingSystem.primary === true && (
                    <FormDropDown
                        label={<FormattedMessage id='Profile_Dwellings_HeatingSystem.renovationType' />}
                        value={props.improvement?.primaryHeatingImprovement}
                        references={props.reference.references?.RenovationType}
                        referencesEvent={() => props.reference.doGetReferences('RenovationType')}
                        changeEvent={(value) =>
                            setAttributeEntity(
                                `${props.baseDotProp}improvement.primaryHeatingImprovement`,
                                value,
                                props.doReducePolicyElement,
                            )
                        }
                        allowEdit
                    />
                )}
                {props.heatingSystem.primary === false && (
                    <FormDropDown
                        label={<FormattedMessage id='Profile_Dwellings_HeatingSystem.renovationType' />}
                        value={props.improvement?.auxiliaryHeatingImprovement}
                        references={props.reference.references?.RenovationType}
                        referencesEvent={() => props.reference.doGetReferences('RenovationType')}
                        changeEvent={(value) =>
                            setAttributeEntity(
                                `${props.baseDotProp}improvement.auxiliaryHeatingImprovement`,
                                value,
                                props.doReducePolicyElement,
                            )
                        }
                        allowEdit
                    />
                )}
                {props.heatingSystem.primary === true &&
                    props.improvement &&
                    props.improvement.primaryHeatingImprovement &&
                    (props.improvement.primaryHeatingImprovement.code === undefined ||
                        props.improvement.primaryHeatingImprovement.value !== 'None') && (
                        <FormInput
                            label={<FormattedMessage id='Profile_Dwellings_HeatingSystem.renovationYear' />}
                            value={
                                props.improvement && props.heatingSystem.primary === true
                                    ? props.improvement.primaryHeatingImprovementYear
                                    : props.improvement.auxiliaryHeatingImprovementYear
                            }
                            changeEvent={(value) =>
                                props.doReducePolicyElement({
                                    code: `${props.baseDotProp}improvement.primaryHeatingImprovementYear`,
                                    value,
                                })
                            }
                            allowEdit
                        />
                    )}
                {props.heatingSystem.primary === false &&
                    props.improvement &&
                    props.improvement.auxiliaryHeatingImprovement &&
                    (props.improvement.auxiliaryHeatingImprovement.code === undefined ||
                        props.improvement.auxiliaryHeatingImprovement.value !== 'None') && (
                        <FormInput
                            label={<FormattedMessage id='Profile_Dwellings_HeatingSystem.renovationYear' />}
                            value={
                                props.improvement && props.heatingSystem.primary === true
                                    ? props.improvement.primaryHeatingImprovementYear
                                    : props.improvement.auxiliaryHeatingImprovementYear
                            }
                            changeEvent={(value) =>
                                props.doReducePolicyElement({
                                    code: `${props.baseDotProp}improvement.auxiliaryHeatingImprovementYear`,
                                    value,
                                })
                            }
                            allowEdit
                        />
                    )}
            </Form>
        </React.Fragment>
    );
};

export default ProfileDwellingHeatingSystem;
